/* eslint-disable @typescript-eslint/no-explicit-any */
import { Collection, CollectionQuery } from "../../../models/collection.model"
import { ParkingActivity } from "../../../models/parking-activity.model"
import { notification } from "../../../shared/component/notification/utility/notification"
import { collectionQueryBuilder } from "../../../shared/utility/collection-builder/collection-query-builder"
import { appApi } from "../../../store/app.api"
import { PARKING_ACTIVITY_ENDPOINT } from "../parking-activity.endpoint"

let tenantCollection: CollectionQuery
let tenantCountCollection: CollectionQuery
let ownersOfTenantCollection: CollectionQuery
let archivedTenantCollection: CollectionQuery
const parkingActivityQuery = appApi.injectEndpoints({
  endpoints: (builder) => ({
    getParkingActivity: builder.query<ParkingActivity, string>({
      query: (id: string) => ({
        url: `${PARKING_ACTIVITY_ENDPOINT.detail}/${id}`,
        method: "get",
      }),
      providesTags: ["Parking Activity"],
    }),

    getParkingActivities: builder.query<
      Collection<ParkingActivity>,
      CollectionQuery
    >({
      query: (data: CollectionQuery) => ({
        url: `${PARKING_ACTIVITY_ENDPOINT.list}`,
        method: "GET",
        params: collectionQueryBuilder(data),
      }),
      providesTags: ["Parking Activities"],

      async onQueryStarted(param, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // if (data) {
          //   SaleCollection = param
          // }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),
    countParkingActivities: builder.query<any, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${PARKING_ACTIVITY_ENDPOINT.list}`,
        method: "GET",
        params: collectionQueryBuilder(data),
      }),
      providesTags: ["Count Parking Activities"],

      async onQueryStarted(param, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // if (data) {
          //   SaleCountCollection = param
          // }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    getArchivedParkingActivity: builder.query<ParkingActivity, string>({
      query: (id: string) => ({
        url: `${PARKING_ACTIVITY_ENDPOINT.archivedParkingActivity}/${id}`,
        method: "get",
      }),
      providesTags: ["Archived Parking Lot"],
    }),

    // getArchivedParkingActivities: builder.query<Collection<Sale>, CollectionQuery>({
    //   query: (data: CollectionQuery) => ({
    //     url: `${PARKING_ACTIVITY_ENDPOINT.archivedParkingActivity}`,
    //     method: "GET",
    //     params: collectionQueryBuilder(data),
    //   }),
    //   providesTags: ["Archived Parking Lots"],
    //   async onQueryStarted(param, { queryFulfilled }) {
    //     try {
    //       const { data } = await queryFulfilled
    //       // if (data) {
    //       //   archivedSaleCollection = param
    //       // }
    //     } catch (error: any) {
    //       notification(
    //         "error",
    //         error?.error?.data?.message
    //           ? error?.error?.data?.message
    //           : "Error try again",
    //       )
    //     }
    //   },
    // }),

    createParkingActivity: builder.mutation<ParkingActivity, any>({
      query: (newData: any) => ({
        url: `${PARKING_ACTIVITY_ENDPOINT.create}`,
        method: "post",
        data: newData,
        permissions: "manage-parking",
      }),
      invalidatesTags: ["Parking Activities", "Count Parking Activities"],
      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully created")
            // dispatch(
            //   parkingActivityQuery.util.updateQueryData(
            //     "getTenants",
            //     tenantCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data.unshift(data)
            //         draft.count += 1
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),
    calculateActivityPrice: builder.mutation<any, any>({
      query: (newData: any) => ({
        url: `${PARKING_ACTIVITY_ENDPOINT.calculateActivityPrice}`,
        method: "post",
        data: newData,
        permissions: "manage-parking",
      }),
      // invalidatesTags: ["Parking Activities", "Count Parking Activities"],
      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully completed")
            // dispatch(
            //   parkingActivityQuery.util.updateQueryData(
            //     "getTenants",
            //     tenantCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data.unshift(data)
            //         draft.count += 1
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    updateParkingActivity: builder.mutation<ParkingActivity, any>({
      query: (newData: any) => ({
        url: `${PARKING_ACTIVITY_ENDPOINT.update}`,
        method: "put",
        data: newData,
        permission: "manage-parking",
      }),
      invalidatesTags: ["Parking Activity", "Parking Activities"],
      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully updated")
            // dispatch(
            //   parkingActivityQuery.util.updateQueryData(
            //     "getTenants",
            //     tenantCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft?.data?.map((tenant) => {
            //           if (tenant.id === data.id) return data
            //           else {
            //             return tenant
            //           }
            //         })
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    toggleParkingActivityStatus: builder.mutation<ParkingActivity, string>({
      query: (id: string) => ({
        url: `${PARKING_ACTIVITY_ENDPOINT.toggleStatus}/${id}`,
        method: "post",
        permission: "manage-parking",
      }),
      invalidatesTags: ["Parking Activity", "Parking Activities"],
      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully updated status")
            // dispatch(
            //   parkingActivityQuery.util.updateQueryData(
            //     "getTenants",
            //     tenantCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft?.data?.map((tenant: Tenant) => {
            //           if (tenant.id === data.id) return data
            //           else {
            //             return tenant
            //           }
            //         })
            //       }
            //     },
            //   ),
            // )
            // dispatch(
            //   parkingActivityQuery.util.updateQueryData("getTenant", param, (draft) => {
            //     draft.enabled = data.enabled
            //   }),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),

    archiveParkingActivity: builder.mutation<
      ParkingActivity,
      { id: string; reason: string }
    >({
      query: (data) => ({
        url: `${PARKING_ACTIVITY_ENDPOINT.archive}`,
        method: "delete",
        data: data,
        permission: "manage-parking",
      }),
      invalidatesTags: ["Parking Activity", "Parking Activities"],
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            // dispatch(
            //   parkingActivityQuery.util.updateQueryData(
            //     "getTenants",
            //     tenantCollection,
            //     (draft) => {
            //       draft.data = draft?.data?.map((tenant) => {
            //         if (tenant.id === arg.id) {
            //           return data
            //         } else {
            //           return tenant
            //         }
            //       })
            //     },
            //   ),
            // )
            // dispatch(
            //   parkingActivityQuery.util.updateQueryData(
            //     "getTenant",
            //     arg?.id,
            //     (draft) => {
            //       draft.deletedAt = data?.deletedAt
            //     },
            //   ),
            // )
            // dispatch(
            //   parkingActivityQuery.util.updateQueryData(
            //     "getArchivedTenant",
            //     arg?.id,
            //     (draft) => {
            //       draft.deletedAt = data?.deletedAt
            //     },
            //   ),
            // )
            notification("success", "Successfully archived")
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),

    deleteParkingActivity: builder.mutation<boolean, string>({
      query: (id: string) => ({
        url: `${PARKING_ACTIVITY_ENDPOINT.delete}/${id}`,
        method: "delete",
        permission: "manage-parking",
      }),
      invalidatesTags: ["Parking Activity", "Parking Activities"],

      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully deleted")
            // dispatch(
            //   parkingActivityQuery.util.updateQueryData(
            //     "getArchivedTenants",
            //     archivedTenantCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft.data.filter((tenant) => tenant.id !== id)
            //         draft.count -= 1
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),

    restoreParkingActivity: builder.mutation<ParkingActivity, string>({
      query: (id: string) => ({
        url: `${PARKING_ACTIVITY_ENDPOINT.restore}/${id}`,
        method: "post",
        permission: "manage-parking",
      }),
      invalidatesTags: ["Parking Lot", "Parking Lots"],

      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            // dispatch(
            //   parkingActivityQuery.util.updateQueryData(
            //     "getTenants",
            //     tenantCollection,
            //     (draft) => {
            //       draft.data = draft?.data?.map((tenant) => {
            //         if (tenant.id === id) {
            //           return data
            //         } else {
            //           return tenant
            //         }
            //       })
            //     },
            //   ),
            // )
            // dispatch(
            //   parkingActivityQuery.util.updateQueryData("getTenant", id, (draft) => {
            //     draft.deletedAt = data?.deletedAt
            //   }),
            // )
            // dispatch(
            //   parkingActivityQuery.util.updateQueryData(
            //     "getArchivedTenant",
            //     id,
            //     (draft) => {
            //       draft.deletedAt = data?.deletedAt
            //     },
            //   ),
            // )
            notification("success", "Successfully restored")
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),
    // removeSalesFile: builder.mutation<
    //   Sale,
    //   { saleId: string; filename: string }
    // >({
    //   query: (data: { saleId: string; filename: string }) => ({
    //     url: `${PARKING_ACTIVITY_ENDPOINT.removeFile}/${data.saleId}/${data.filename}`,
    //     method: "post",
    //     permission: "manage-sales",
    //   }),
    //   invalidatesTags: ["Sale", "Sales"],

    //   async onQueryStarted(id, { dispatch, queryFulfilled }) {
    //     try {
    //       const { data } = await queryFulfilled
    //       if (data) {
    //         notification("success", "Successfully deleted")
    //         // dispatch(
    //         //   leaseQuery.util.updateQueryData(
    //         //     "getRentIncreases",
    //         //     rentIncreaseCollection,
    //         //     (draft) => {
    //         //       if (data) {
    //         //         draft.data = draft.data.filter(
    //         //           (rentIncrease) => rentIncrease.id !== id,
    //         //         )
    //         //         draft.count -= 1
    //         //       }
    //         //     },
    //         //   ),
    //         // )
    //       }
    //     } catch (error: any) {
    //       notification(
    //         "error",
    //         error?.error?.data?.message ?? "Error try again",
    //       )
    //     }
    //   },
    // }),
  }),
  overrideExisting: true,
})
export const {
  useLazyCountParkingActivitiesQuery,
  useLazyGetArchivedParkingActivityQuery,
  useLazyGetParkingActivitiesQuery,
  useLazyGetParkingActivityQuery,
  useDeleteParkingActivityMutation,
  useToggleParkingActivityStatusMutation,

  useUpdateParkingActivityMutation,
  useCreateParkingActivityMutation,
  useArchiveParkingActivityMutation,
  useRestoreParkingActivityMutation,
  useCalculateActivityPriceMutation
} = parkingActivityQuery
